<template>
  <div class="page-card">
    <h2 class="page-title">通告大厅</h2>

    <div class="toolbar">
      <div class="toolbar-left">
        <el-input
          v-model="query.keyword"
          placeholder="标题关键字"
          clearable
          style="width: 240px"
        />
        <el-select v-model="query.status" clearable placeholder="状态" style="width: 160px">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="query.publishSourceCategory" placeholder="来源分类" style="width: 180px">
          <el-option v-for="item in publishSourceCategoryOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-button type="primary" @click="fetchData">查询</el-button>
        <el-button @click="goPrivateMessages">私信管理</el-button>
      </div>
      <el-button v-if="canPublish" type="primary" icon="el-icon-plus" @click="goPublish">发送通告</el-button>
    </div>

    <el-table :data="list" border>
      <el-table-column prop="id" label="通告ID" width="110" />
      <el-table-column prop="submitterName" label="通告标题" min-width="200" />
      <el-table-column label="发布来源" width="110">
        <template slot-scope="{ row }">{{ row.publishSourceText || '商家自发' }}</template>
      </el-table-column>
      <el-table-column label="主题/商家" min-width="160">
        <template slot-scope="{ row }">
          {{ row.subjectMerchantName || row.merchantDisplayName || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="曝光值" width="110" align="right">
        <template slot-scope="{ row }">{{ row.exposureValue || 0 }}</template>
      </el-table-column>
      <el-table-column prop="submitTime" label="创建时间" width="180" />
      <el-table-column prop="updatedAt" label="更新时间" width="180" />
      <el-table-column label="状态" width="140">
        <template slot-scope="{ row }">
          <el-tag :type="statusTagType(row.status)">{{ statusLabel(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="440">
        <template slot-scope="{ row }">
          <div class="action-group">
            <el-button type="text" @click="viewDetail(row)">查看详情</el-button>
            <div v-if="row.adminManaged && row.status === 5" class="manage-action">
              <el-button type="text" @click="goManage(row)">招募管理</el-button>
              <span v-if="showPendingBadge(row)" class="pending-badge">{{ badgeValue(recruitmentBadgeCount(row)) }}</span>
            </div>
            <div class="manage-action">
              <el-button type="text" @click="goOrderPrivateMessages(row)">订单私信</el-button>
              <span v-if="showOrderPrivateMessageBadge(row)" class="pending-badge">{{ badgeValue(orderPrivateMessageBadgeCount(row)) }}</span>
            </div>
            <el-button v-if="row.status === 5" type="text" @click="changeStatus(row, 'off')">下架</el-button>
            <el-button v-if="row.status === 6" type="text" @click="changeStatus(row, 'on')">上架</el-button>
            <el-button v-if="row.status === 5 || row.status === 6" type="text" @click="changeStatus(row, 'ban')">封禁</el-button>
            <el-button v-if="row.status === 9" type="text" @click="changeStatus(row, 'unban')">解封</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui'
import { getCastingNoticeAudits,
  banCastingNotice,
  offShelfCastingNotice,
  onShelfCastingNotice,
  unbanCastingNotice
} from '../../../api/audit'
import { navigateWithFallback } from '../../../utils/admin-navigation'
import { badgeValue, recruitmentHallRowBadgeCount } from '../../../utils/recruitment-badges'
import { hasPermission } from '../../../utils/auth'

const statusOptions = [
  { label: '招募中', value: 5 },
  { label: '招募结束', value: 8 },
  { label: '已下架', value: 6 },
  { label: '已封禁', value: 9 }
]

const publishSourceCategoryOptions = [
  { label: '平台发送/平台代发', value: 'admin' },
  { label: '其他', value: 'other' }
]

export default {
  name: 'CastingHallPage',
  data() {
    return {
      list: [],
      query: {
        keyword: '',
        status: 5,
        publishSourceCategory: 'admin'
      },
      pollTimer: null,
      statusOptions,
      publishSourceCategoryOptions
    }
  },
  computed: {
    canPublish() {
      return hasPermission('casting_notice:publish')
    }
  },
  created() {
    const routeStatus = this.$route.query.status
    if (routeStatus) {
      this.query.status = Number(routeStatus)
    }
    this.fetchData()
    this.startPolling()
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    async fetchData(options = {}) {
      const list = await getCastingNoticeAudits({
        keyword: this.query.keyword || undefined,
        status: this.query.status || undefined,
        publishSourceCategory: this.query.publishSourceCategory || undefined
      })
      this.list = list || []
    },
    startPolling() {
      this.stopPolling()
      this.pollTimer = window.setInterval(() => {
        this.fetchData({ silent: true })
      }, 20000)
    },
    stopPolling() {
      if (this.pollTimer) {
        window.clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    statusLabel(status) {
      if (status === 5) return '招募中'
      if (status === 8) return '招募结束'
      if (status === 6) return '已下架'
      if (status === 9) return '已封禁'
      if (status === 2) return '待审核'
      if (status === 4) return '已驳回'
      return status == null ? '-' : String(status)
    },
    statusTagType(status) {
      if (status === 5) return 'success'
      if (status === 8) return 'info'
      if (status === 6) return 'warning'
      if (status === 9) return 'danger'
      return 'info'
    },
    badgeValue,
    recruitmentBadgeCount: recruitmentHallRowBadgeCount,
    showPendingBadge(row) {
      return this.recruitmentBadgeCount(row) > 0
    },
    orderPrivateMessageBadgeCount(row) {
      return Number((row && row.orderPrivateMessageUnreadCount) || 0)
    },
    showOrderPrivateMessageBadge(row) {
      return this.orderPrivateMessageBadgeCount(row) > 0
    },
    viewDetail(row) {
      navigateWithFallback(this, {
        path: `/audits/casting-notice/${row.id}`,
        query: {
          from: 'hall',
          fromStatus: String(this.query.status || 5)
        }
      })
    },
    goPublish() {
      this.$router.push('/casting/publish')
    },
    goManage(row) {
      this.$router.push(`/casting/manage/${row.id}`)
    },
    goOrderPrivateMessages(row) {
      this.$router.push({
        path: '/platform/private-messages',
        query: {
          noticeId: String(row.id),
          noticeTitle: row.submitterName || '',
          autoOpen: '1'
        }
      })
    },
    async changeStatus(row, action) {
      const configMap = {
        off: { text: '下架', api: offShelfCastingNotice },
        on: { text: '上架', api: onShelfCastingNotice },
        ban: { text: '封禁', api: banCastingNotice },
        unban: { text: '解封', api: unbanCastingNotice }
      }
      const config = configMap[action]
      if (!config) return

      if (action === 'ban') {
        let promptResult
        try {
          promptResult = await MessageBox.prompt('请输入封禁原因', '封禁通告', {
            confirmButtonText: '确认封禁',
            cancelButtonText: '取消',
            inputPlaceholder: '请填写审核拒绝/封禁原因',
            inputValidator: value => (value && value.trim() ? true : '请填写封禁原因')
          })
        } catch (e) {
          return
        }
        await config.api(row.id, { remark: promptResult.value.trim() })
        this.$message.success(`${config.text}成功`)
        await this.fetchData()
        return
      }

      try {
        await MessageBox.confirm(`确认${config.text}该通告吗？`, '操作确认', {
          type: 'warning',
          confirmButtonText: '确认',
          cancelButtonText: '取消'
        })
      } catch (e) {
        return
      }
      await config.api(row.id, {})
      this.$message.success(`${config.text}成功`)
      await this.fetchData()
    },
    goPrivateMessages() {
      this.$router.push('/platform/private-messages')
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.toolbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.action-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 12px;
  row-gap: 6px;
}

.action-group :deep(.el-button--text) {
  margin: 0;
  padding: 0;
}

.manage-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.pending-badge {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #f56c6c;
  color: #fff;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  font-weight: 600;
  box-sizing: border-box;
}
</style>
